<div class="title">Generate Offer Package</div>
<div class="information">
  <span>We've prepared your offer sheet!</span>
  <span>Share the URL below to the seller for downloading</span>
</div>

<label class="arb-input">
  <span class="title">URL</span>
  <input #url type="text" [value]="packageUrl" readonly>
  <mat-icon (click)="onCopy()" class="copy-icon" svgIcon="copy"></mat-icon>
</label>

<div class="actions">
  <button mat-flat-button class="close-button" mat-dialog-close>Close</button>
</div>